import React, { useRef } from 'react';
import { ModalContainerProps, ModalContainer } from '@vw-marketing/us-components';
import ModelExtendedCard from './model-extended-card';
import { ReviewModel } from '../../typings/reviews';
import ReviewsPages from '../../components/reviews-pages';
import { disabledScroll, unsetPagemainZindex } from '../../utils/general';
import { AllReviewsContainer, StyledModalWrapper } from './styled';
import { FeatureAppTrackingManager } from '../../services/use-tracking-manager';
// import { onHandleLayerLoadTrackEvent } from '../../utils/tracking-helpers';

interface AllReviewsProps extends ModalContainerProps {
  reviews?: ReviewModel;
  trackingManager: FeatureAppTrackingManager;
}

const AllReviews: React.FC<AllReviewsProps> = props => {
  const { onCloseHandler, reviews, active, trackingManager } = props;
  
  let modalRef = useRef<HTMLElement | null>(null);
  const scrollToTop = () => {
    modalRef.current &&
      modalRef.current.scrollTo({
        top: 100,
        behavior: 'smooth',
      });
  };

  React.useEffect(() => {
    // Avoid the navigation menu overlap issue
    unsetPagemainZindex();
  }, []);

  React.useEffect(() => {
    disabledScroll(active);
    // active && onHandleLayerLoadTrackEvent(trackingManager, reviews)
  }, [active]);

  return (
    <StyledModalWrapper>
      <ModalContainer
        active={active}
        onCloseHandler={onCloseHandler}
        scrollRef={modalRef}
      >
        <AllReviewsContainer>
          <ModelExtendedCard
            review={reviews}
            model={reviews?.modelConfiguration}
          />
          <ReviewsPages
            reviews={reviews}
            scrollHandler={scrollToTop}
            trackingManager={trackingManager}
          />
        </AllReviewsContainer>
      </ModalContainer>
    </StyledModalWrapper>
  );
};

export default AllReviews;
